// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../_css-loader@6.11.0@css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../_css-loader@6.11.0@css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".van-cell-group{background-color:#fff}.van-cell-group--inset{margin:0 4.266667vw;overflow:hidden;border-radius:2.133333vw}.van-cell-group__title{padding:4.266667vw 4.266667vw 2.133333vw;color:#969799;font-size:3.733333vw;line-height:4.266667vw}.van-cell-group__title--inset{padding:4.266667vw 4.266667vw 2.133333vw 8.533333vw}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
